export const languages = ['ru', 'en'];


// WEBPACK FOOTER //
// ./src/services/languages.js